import React from 'react';

const ErrorMessage = () => (
  <div className="error schedule-error">
    Please ensure the start times are earlier than the stop times.
  </div>
);

export default ErrorMessage;
